
import React, { FC, useState } from 'react';
import styled, {css} from '@emotion/native';
import { Text } from '@components/1-atoms';
import _ from 'underscore';
import { ListSectionHeader } from '@components/2-molecules/ListItem';

import { ListItem as ListItemBase, } from '@components/2-molecules';
import Account from './StatementAccountItem';

const ListItem = styled(ListItemBase)`
   text-transform: capitalize;
`;


type Props = { data: any; }

const AccountType: FC<Props> = ({ data, ...props }) => {

    const Accounts = data?.accounts.length && data?.accounts.map((account: any) => <Account data={account} />);
    
    return (
        <>
            <ListSectionHeader children={data.name} />
            {Accounts}
            
            <ListItem hideLine bg={`#EEEFFF`} bold height={45} right={<Text preffix={"$ "} bold>{data.balance.toFixed(2)}</Text>}> {`Total ${data.name}`} </ListItem>
        </>
    );
};

export default AccountType;